export enum NotificationSurface {
  APP_MODAL = 'app_modal',
}

export enum NotificationStatus {
  DRAFT = 'draft',
  SCHEDULED = 'scheduled',
  ACTIVE = 'active',
  ARCHIVED = 'archived',
}

export enum NotificationAudienceType {
  ALL_USERS = 'all_users',
  TEST_USERS = 'test_users',
  TRIALING_USERS = 'trialing_users',
  ACTIVE_SUBSCRIBERS = 'active_subscribers',
  CANCELED_USERS = 'canceled_users',
}

export enum NotificationPlatform {
  ALL = 'all',
  WEB = 'web',
  IOS = 'ios',
  ANDROID = 'android',
}

export interface AppNotification {
  id: number;
  slug: string;
  surface: NotificationSurface;
  status: NotificationStatus;
  title: string;
  body: string;
  image_url?: string | null;
  cta_label?: string | null;
  cta_url?: string | null;
  dismissible: boolean;
  priority: number;
  starts_at?: string | null;
  ends_at?: string | null;
  required_feature_flag?: string | null;
  audience_type: NotificationAudienceType;
  audience_filters?: Record<string, unknown> | null;
  platform: NotificationPlatform;
  created_by?: string | null;
  updated_by?: string | null;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
}

export interface NotificationLocalState {
  lastShownAt?: string;
  impressionRecordedAt?: string;
  dismissedAt?: string;
  ctaClickedAt?: string;
  completedAt?: string;
}
